import { useRef } from 'react';

import { generateElementId } from '../../utils/id/generate-element-id';

export function useAriaErrorMessageId(error: boolean | undefined, prefix?: string) {
   const idRef = useRef(generateElementId(prefix ? `${prefix}-error` : undefined));
   if (error) return idRef.current;
   return undefined;
}
